<div class="layout-cotainer">
    <div class="layout-background-image">
    </div>
    <div class="layout-form-container">
        <div class="global-header-logo-row">
            <img class="global-header-logo" src="assets/icons/coca-cola-logo.svg" alt="Coca-Cola" />
        </div>
        <div class="layout-steps" [ngSwitch]="currentStep">
            <app-potential-customer *ngSwitchCase="1" class="form-component" (onBack)="backForm()" (onComplete)="changeForm($event)"></app-potential-customer>
            <app-confirm-location *ngSwitchCase="2" class="form-component" (onBack)="backForm()" (onComplete)="changeForm($event)"></app-confirm-location>
            <app-sales-validation *ngSwitchCase="3" class="form-component" (onBack)="backForm()" (onComplete)="changeForm($event)"></app-sales-validation>
            <app-tax-validation *ngSwitchCase="4" class="form-component" (onBack)="backForm()" (onComplete)="changeForm($event)"></app-tax-validation>
            <app-file-upload *ngSwitchCase="5" class="form-component" (onBack)="backForm()" (onComplete)="changeForm($event)"></app-file-upload>
            <app-contact-information *ngSwitchCase="6" class="form-component" (onBack)="backForm()" (onComplete)="changeForm($event)"></app-contact-information>
            <!-- <app-validation-code *ngSwitchCase="6" (onBack)="backForm()" (onComplete)="changeForm($event)" class="form-component"> </app-validation-code> -->
            <app-register-complete *ngSwitchCase="7" class="form-component"></app-register-complete>
        </div>
        <app-version></app-version>
    </div>
</div>

